import React from "react";

export default function HeaderAccount({
  credit,
  deposit_wallet,
  deposit,
  pl,
  withdraw_wallet,
  withdraw,
  nse_cash,
}) {
  return (
    <div className="px-5 py-3 border-b-2 border-[var(--hover)] text-[14px] space-y-1 text-[var(--text)]">
      {deposit_wallet > 0 ? (
        <div className="flex justify-between">
          <span className="font-semibold">Wallet Deposit :</span>
          <span className={`font-semibold text-[var(--buy)]`}>
            {parseFloat(deposit_wallet).toFixed(2)}
          </span>
        </div>
      ) : null}

      <div className="flex justify-between">
        <span className="font-semibold">Deposit :</span>
        <span className={`font-semibold text-[var(--buy)]`}>
          {parseFloat(deposit).toFixed(2)}
        </span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">Account P&L :</span>
        <span className={`font-semibold text-[var(--buymeta)]`}>
          {parseFloat(pl).toFixed(2)}
        </span>
      </div>

      {withdraw_wallet > 0 ? (
        <div className="flex justify-between">
          <span className="font-semibold">Wallet Withdraw :</span>
          <span className={`font-semibold text-[var(--sellmeta)]`}>
            {parseFloat(withdraw_wallet).toFixed(2)}
          </span>
        </div>
      ) : null}

      <div className="flex justify-between">
        <span className="font-semibold"> Withdraw :</span>
        <span className={`font-semibold text-[var(--sellmeta)]`}>
          {parseFloat(withdraw).toFixed(2)}
        </span>
      </div>
      {nse_cash === 1 ? (
        <div className="flex justify-between">
          <span className="font-semibold">Cash Deposit :</span>
          <span className={`font-semibold text-[var(--buy)]`}>
            {parseFloat(credit).toFixed(2)}
          </span>
        </div>
      ) : null}
    </div>
  );
}
